import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/site/SEO";
import { articles } from "@/data/articles";
import { breadcrumbSchema } from "@/data/site";

export default function Insights() {
  return (
    <div className="bg-white text-brand-black">
      <SEO
        title="Insights · Real Estate Listing Reading"
        description="Short pieces on listing standards, seller experience, buyer trust, and the operating model behind consistent property presentation."
        path="/insights"
        schema={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Insights", path: "/insights" }])]}
      />
      <section className="bg-brand-black text-white">
        <div className="mx-auto max-w-[1360px] px-5 md:px-10 py-24 md:py-32">
          <div className="eyebrow text-white/60">Insights</div>
          <h1 className="mt-4 text-[40px] md:text-7xl font-bold tracking-[-0.02em] leading-[1.0] max-w-4xl">
            Reading for people who take listings seriously.
          </h1>
          <p className="mt-8 max-w-2xl text-[16px] leading-relaxed text-white/70">
            Short pieces on listing standards, seller experience, buyer trust, and the operating
            model behind consistent presentation.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-[1360px] px-5 md:px-10 py-20 md:py-28">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="insights-grid">
            {articles.map((a, i) => (
              <Link
                key={a.slug}
                to={`/insights/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="group border border-brand-gray/25 p-6 bg-white hover:border-brand-black transition-colors flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <span className="text-[10px] tracking-[0.22em] uppercase text-brand-gray">Article {String(i + 1).padStart(2, "0")}</span>
                  <span className="text-[10px] tracking-[0.22em] uppercase text-brand-blue">{a.tag}</span>
                </div>
                <h3 className="mt-4 text-[19px] md:text-[20px] font-bold tracking-tight leading-snug group-hover:text-brand-violet transition-colors">
                  {a.title}
                </h3>
                <p className="mt-3 text-[14px] leading-relaxed text-brand-gray line-clamp-3">{a.summary}</p>
                <div className="mt-6 pt-4 border-t border-brand-gray/20 flex items-center justify-between text-[11px] tracking-[0.18em] uppercase text-brand-gray">
                  <span>{a.readingTime}</span>
                  <ArrowUpRight className="h-4 w-4 text-brand-black transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
